// removed by extract-text-webpack-plugin
module.exports = {"Card":"z_VwcWbv95OOBOszyKvzP","Body":"_1eEfYFazKWm5YOLPpns0ue","Group":"_3MQtKyClSiICn0rp3a5Tl9","Title":"qTeHfdRKBL2Ey5zt-QaZh","Column":"do9RNJvEbohPEsKPUYxO1","CheckboxWrap":"_2KX4zefTkxYY2PnezgipMN","CustomCheckbox":"_1lcQnRV3noXDZiNhpl3FUu","StatusDot":"gpm0122Xi9P9F6vo30oew","Footer":"_3hTd_Ht3QeL7bz_heP0h9r","Submit":"_1OXKi4KJ_13zTNvwCFCv8r","buttonIcon":"-Pa7xcaNTDNxG_tNmLRwt","Reset":"nqtAay-wsxZCXZadMTKI6"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/ComponentsOfAdministrator/DisputeFilters/styles.module.css
// module id = 542
// module chunks = 0